import { CaretRight } from '@phosphor-icons/react/dist/ssr'
import Link from 'next/link'

import { Button as ButtonUI } from '@/components/ui/button'
import { cn } from '@/lib/utils'

import { Loader } from '../Loader/Loader'

import type { ButtonHTMLAttributes } from 'react'

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  size?: 'small' | 'medium' | 'large'
  variant?: 'solid' | 'outline' | 'light' | 'plain' | 'light-outline'
  loading?: boolean
}

type ButtonLinkProps = ButtonProps & {
  href?: string
}

const loaderType = {
  outline: 'dark',
  solid: 'default',
  light: 'light',
  'light-outline': 'dark',
}

export const Button = ({ size = 'medium', children, variant = 'solid', loading = false, ...props }: ButtonProps) => {
  return (
    <ButtonUI type="button" variant={variant} size={size} loading={loading} {...props}>
      {variant === 'plain' && (
        <div className="flex items-center justify-center">
          {children} <CaretRight size={16} />
        </div>
      )}
      {loading && variant !== 'plain' && <Loader type={loaderType[variant] as 'default' | 'dark' | 'light'} />}
      {!loading && variant !== 'plain' && children}
    </ButtonUI>
  )
}

export const ButtonLink = ({ size = 'medium', children, variant = 'solid', loading = false, href, ...props }: ButtonLinkProps) => {
  return (
    <ButtonUI
      type="button"
      variant={variant}
      size={size}
      loading={loading}
      asChild={!props.disabled}
      className={cn(variant === 'plain' && 'h-fit px-0', props.className)}
      {...props}
    >
      <Link href={href ?? '/'} className={props.className}>
        {variant === 'plain' ? (
          <div className="flex w-full items-center justify-center">
            {children} <CaretRight size={16} />
          </div>
        ) : (
          children
        )}
      </Link>
    </ButtonUI>
  )
}
